import { AxiosRequestConfig } from 'axios';

import { BASE_API } from '../utils';

interface CreateConfig extends AxiosRequestConfig {
  method: 'POST';
  url: `/exams/${string}/locked-problems`;
}

/**
 * creates all missing locked exam problems
 */
export const create = (examTemplateId: string): CreateConfig => {
  return {
    baseURL: BASE_API,
    method: 'POST',
    url: `/exams/${examTemplateId}/locked-problems`,
  } as const;
};
